<div
  class="picker flex flex-col"
  (mouseenter)="activateDropDown()"
  (mouseleave)="deactivateDropDown()">
  <span class="picker-header" *ngIf="switcher === boxType.NUMBER">Display in</span>
  <span class="picker-header" *ngIf="switcher === boxType.DATE">Group by</span>
  <div data-qa="switcher-selected" class="picker-name" [ngSwitch]="currentActiveBox">
    <span *ngSwitchCase="1">{{ boxes[switcher].box1 }}</span>
    <span *ngSwitchCase="2">{{ boxes[switcher].box2 }}</span>
    <span *ngSwitchCase="3">{{ boxes[switcher].box3 }}</span>
    <span *ngSwitchCase="4">{{ boxes.dates.box4 }}</span>
    <div class="xAxis-whitespace-xtiny"></div>
    <app-all-icons [iconNameAndStyling]="'arrow-down.svg;icon-size-1p25'"></app-all-icons>
  </div>

  <div
    *ngIf="show"
    @fadeInOut
    class="picker-dropdown flex flex-col">
    <div class="flex flex-col picker-list">
      <div class="flex flex-col list-block">
        <span
          data-qa="switcher-entry-1"
          class="list-entry"
          [class.selected]="activeBoxes.box1"
          (click)="boxClicked(1)">
          {{boxes[switcher].box1}}
        </span>
        <span
          data-qa="switcher-entry-2"
          class="list-entry"
          [class.selected]="activeBoxes.box2"
          (click)="boxClicked(2)">
          {{boxes[switcher].box2}}
        </span>
        <span
          data-qa="switcher-entry-3"
          class="list-entry"
          [class.selected]="activeBoxes.box3"
          (click)="boxClicked(3)">
          {{boxes[switcher].box3}}
        </span>
        <span
          *ngIf="switcher === boxType.DATE"
          data-qa="switcher-entry-4"
          class="list-entry"
          [class.selected]="activeBoxes.box4"
          (click)="boxClicked(4)">
          {{boxes.dates.box4}}
        </span>
      </div>
    </div>
  </div>
</div>
